import { request } from '@/util/http'

export const getList0 = (current, size, params) => {
  return request({
    url: '/health/guidanceSleepDiaryImprove/list0',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getList1 = (current, size, params) => {
  return request({
    url: '/health/guidanceSleepDiaryImprove/list1',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/guidanceSleepDiaryImprove/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/guidanceSleepDiaryImprove/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/guidanceSleepDiaryImprove/submit',
    method: 'post',
    data: row
  })
}

